<template>
	<div class="container">
		<h2>Roles</h2>
		<div>
			<a href="#" @click.prevent="setStatusFilter('true')"
				:class="{ 'font-weight-bold': statusFilter === 'true' }">Active</a> |
			<a href="#" @click.prevent="setStatusFilter('false')"
				:class="{ 'font-weight-bold': statusFilter === 'false' }">Inactive</a>
		</div>
		<div class="my-3">
            <button class="btn btn-primary" @click="createRole">New Role</button>
        </div>
		<div :key="tableContainerKey">
			<table id="rolesTable" class="display" style="width:100%">
				<thead>
					<tr>
						<th class="col-code text-center">CODE</th>
						<th class="col-description text-center">DESCRIPTION</th>
						<th class="text-center">PERMISSIONS</th>
						<th class="col-status text-center">STATUS</th>
						<th class="col-empty text-center">&nbsp;</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="role in roles" :key="role.id">
						<td>{{ role.code }}</td>
						<td>{{ role.description }}</td>
						<td>{{ formatPermissions(role.permissions) }}</td>
						<td :class="role.active ? 'text-success' : 'text-danger'" class="text-center">{{ role.active ? 'Active' : 'Inactive' }}</td>
						<td>
							<button class="btn text-primary" title="Edit" @click="editRole(role.id)">
								<i class="fas fa-edit"></i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import api from '@/api';
import eventBus from '@/utils/eventBus';
import { checkAuth } from '@/utils/auth';

export default {
	data() {
		return {
			roles: [],
			statusFilter: 'true', // Default filter for active roles
			tableContainerKey: 0 // Changing this key forces the table container to re-render
		};
	},
	async mounted() {
		if (!(await checkAuth())) {
			eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
			this.$router.push('/');
		} else {
			this.fetchRoles();
		}
	},
	methods: {
		async fetchRoles() {			
			try {
				const response = await api.get('/v1/roles', {
					headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
					params: { active: this.statusFilter }
				});
				if (response.status === 200 && response.data.data) {
                    this.roles = Array.isArray(response.data.data.roles) ? response.data.data.roles : [];
				} else {
					this.roles = [];
				}
				this.tableContainerKey++;
				this.$nextTick(() => {
					// Use a slight delay to ensure the new table is in place.
					setTimeout(() => {
						// Remove any leftover DataTable wrapper from previous instances.
						if ($.fn.DataTable.isDataTable('#rolesTable')) {
							$('#rolesTable').DataTable().destroy(true);
							$('#rolesTable_wrapper').remove();
						}
						$('#rolesTable').DataTable({
							// You can add additional DataTables options here
						});
					}, 100);
				});
			} catch (error) {
				console.error('Error fetching roles:', error);
                this.roles = [];
				if (error.response.data.message) {
					eventBus.emit('show-alert', { message: error.response.data.message, type: 'danger' });
				} else {
					eventBus.emit('show-alert', { message: 'Error fetching roles.', type: 'danger' });
				}
			}
		},
		formatPermissions(permissions) {
			if (!permissions) return '';
			const formattedPermissions = permissions.split(',').map((permission) => permission.trim());
			return formattedPermissions.join(', ');
		},
		async setStatusFilter(status) {
			this.statusFilter = status;
			await this.fetchRoles();
		},
		createRole() {
            this.$router.push('/roles/new');
        },
		editRole(roleId) {
			this.$router.push(`/roles/${roleId}`);
		}
	},
	beforeUnmount() {
		if ($.fn.DataTable.isDataTable('#rolesTable')) {
			$('#rolesTable').DataTable().destroy(true);
			$('#rolesTable_wrapper').remove();
		}
	}
};
</script>

<style>
.font-weight-bold {
	font-weight: bold;
}

.col-code {
	width: 15%;
}

.col-description {
	width: 25%;
}

.col-status {
	width: 10%;
}

.col-empty {
	width: 5%;
}
</style>